import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import Tracking from 'medscape/tracking';
import ZoomButton from './zoom-button';
import ZoomLayer from './zoom-layer';

export default class ZoomImage extends React.Component {
  constructor(props){
    super(props);
    props.default.image.src = Utils.getCompiledHtml(props.default.image.src)
    this.state = {
    }

  }
  componentDidMount(){
    let $this = $(ReactDOM.findDOMNode(this));
  }

  componentWillUnmount(){  
  }
  doZoom(e){
    this.props.onZoom(e);
    ZoomLayer.open(this.props.enlarged);
  }
  render() {
    const config = window.medscape.isMobile ? this.props.mobile : this.props.desktop;
    if(config.isActive){
      if(config.showIcon){
        return(
          <div className="module-wrapper">
            <img {...this.props.default.image} onClick={this.doZoom.bind(this)} />
            <ZoomButton onClick={this.doZoom.bind(this)} />
          </div>
        )
      }
      else{
        return(
          <div className="module-wrapper">
            <img {...this.props.default.image} onClick={this.doZoom.bind(this)} />
          </div>
        );
      }
    }
    else{
      return(
        <div className="module-wrapper no-zoom">
          <img {...this.props.default.image} />
        </div>
      )
    }
  }
}

ZoomImage.propTypes={
    "config-id": React.PropTypes.string,
    "default": React.PropTypes.object,
    "enlarged": React.PropTypes.object,
    "mobile": React.PropTypes.object,
    "desktop": React.PropTypes.object,
    "onZoom": React.PropTypes.func
}
ZoomImage.defaultProps=  {
    onZoom: ()=>{}
}



// WEBPACK FOOTER //
// ./src/app/zoom-images/zoom-image.jsx